/* Wagner Beauty theme — vanilla, no dependencies. */
(() => {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    if (window.WB && window.WB.b2bNet) cents = Math.round(cents / 1.19);
    const fmt = window.WB?.moneyFormat || '{{amount_with_comma_separator}} €';
    const v = (cents / 100);
    const withComma = v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = v.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return fmt
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDec)
      .replace('{{amount}}', v.toFixed(2))
      .replace('{{amount_no_decimals}}', String(Math.round(v)))
      .replace(/<[^>]*>/g, '');
  };
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem('wb:' + k)) ?? d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem('wb:' + k, JSON.stringify(v)); } catch {} }
  };
  const debounce = (fn, ms = 220) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const trapFocus = (el) => {
    const sel = 'a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
    const nodes = $$(sel, el).filter((n) => n.offsetParent !== null);
    if (nodes.length) nodes[0].focus();
    el.__trap = (e) => {
      if (e.key !== 'Tab') return;
      const list = $$(sel, el).filter((n) => n.offsetParent !== null);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    el.addEventListener('keydown', el.__trap);
  };
  const releaseFocus = (el) => { if (el.__trap) el.removeEventListener('keydown', el.__trap); };

  let toastTimer;
  function toast(msg) {
    let t = $('#wb-toast');
    if (!t) { t = document.createElement('div'); t.id = 'wb-toast'; t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.dataset.open = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (t.dataset.open = 'false'), 2600);
  }
  window.WBToast = toast;

  /* ── Panels: cart drawer, search modal, mobile nav ── */
  const body = document.body;
  let lastFocus = null;
  function openPanel(id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    lastFocus = document.activeElement;
    $$('[data-panel]').forEach((p) => { if (p.id !== id) p.dataset.open = 'false'; });
    panel.dataset.open = 'true';
    const ov = $('#wb-overlay'); if (ov) ov.dataset.open = 'true';
    body.style.overflow = 'hidden';
    panel.dispatchEvent(new CustomEvent('panel:open'));
    setTimeout(() => trapFocus(panel), 60);
  }
  function closePanels() {
    $$('[data-panel]').forEach((p) => { p.dataset.open = 'false'; releaseFocus(p); });
    const ov = $('#wb-overlay'); if (ov) ov.dataset.open = 'false';
    body.style.overflow = '';
    if (lastFocus) { try { lastFocus.focus(); } catch {} }
  }
  window.WBPanel = { open: openPanel, close: closePanels };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-panel]');
    if (opener) { e.preventDefault(); openPanel(opener.dataset.openPanel); return; }
    if (e.target.closest('[data-close-panel]')) { e.preventDefault(); closePanels(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closePanels();
    const mega = document.activeElement?.closest?.('.has-mega');
    if (mega) { document.activeElement.blur(); mega.querySelector('a')?.focus(); }
  });

  /* ── Sticky header shadow ── */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => (header.dataset.stuck = window.scrollY > 8 ? 'true' : 'false');
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Cart ─────────────────────────────────────────── */
  const CART_SECTIONS = ['cart-drawer', 'cart-bubble'];
  async function cartRequest(url, payload) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections: CART_SECTIONS, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
    return data;
  }
  function renderSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-section-content="' + id + '"]');
      const target = $('[data-section-content="' + id + '"]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  async function addToCart(items, opts = {}) {
    const data = await cartRequest(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { items });
    renderSections(data.sections);
    if (window.WB?.cartDrawer && !opts.silent) openPanel('cart-drawer');
    else toast(window.WB?.strings?.added || 'Hinzugefügt');
    return data;
  }
  window.WBCart = {
    add: addToCart,
    async change(payload) {
      const data = await cartRequest('/cart/change.js', payload);
      renderSections(data.sections);
      return data;
    }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-atc]');
    const label = btn?.querySelector('[data-atc-label]');
    const prev = label?.textContent;
    if (btn) { btn.dataset.loading = 'true'; if (label) label.textContent = window.WB?.strings?.adding || 'Wird hinzugefügt'; }
    try {
      const fd = new FormData(form);
      await addToCart([{ id: fd.get('id'), quantity: Number(fd.get('quantity') || 1), selling_plan: fd.get('selling_plan') || undefined }]);
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) { btn.dataset.loading = 'false'; if (label && prev) label.textContent = prev; }
    }
  });

  /* line item quantity + remove inside drawer / cart page */
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const dir = Number(step.dataset.qtyStep);
      const stepBy = Number(input.step || 1);
      const next = Math.max(Number(input.min || 0), Number(input.value) + dir * stepBy);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      const root = rm.closest('[data-line]');
      if (root) root.dataset.loading = 'true';
      try { await window.WBCart.change({ line: Number(rm.dataset.lineRemove), quantity: 0 }); }
      catch (err) { toast(err.message); if (root) root.dataset.loading = 'false'; }
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    const root = input.closest('[data-line]');
    if (root) root.dataset.loading = 'true';
    try { await window.WBCart.change({ line: Number(input.dataset.lineQty), quantity: Number(input.value) }); }
    catch (err) { toast(err.message); if (root) root.dataset.loading = 'false'; }
  });

  /* cart note */
  const noteHandler = debounce(async (val) => {
    await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: val })
    });
  }, 500);
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-cart-note]')) noteHandler(e.target.value);
  });

  /* ── Predictive search ────────────────────────────── */
  class PredictiveSearch {
    constructor(root) {
      this.root = root;
      this.input = $('input[type="search"]', root);
      this.results = $('[data-ps-results]', root);
      this.defaults = $('[data-ps-default]', root);
      this.abort = null;
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', debounce(() => this.run(), 200));
      this.input.addEventListener('keydown', (e) => this.nav(e));
      root.addEventListener('panel:open', () => setTimeout(() => this.input.focus(), 80));
    }
    nav(e) {
      if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;
      const items = $$('.ps-item', this.results);
      if (!items.length) return;
      let i = items.findIndex((n) => n.getAttribute('aria-selected') === 'true');
      if (e.key === 'Enter') { if (i > -1) { e.preventDefault(); items[i].click(); } return; }
      e.preventDefault();
      items.forEach((n) => n.setAttribute('aria-selected', 'false'));
      i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1);
      items[i].setAttribute('aria-selected', 'true');
    }
    async run() {
      const q = this.input.value.trim();
      if (this.defaults) this.defaults.hidden = q.length > 0;
      if (q.length < 1) { this.results.innerHTML = ''; return; }
      this.abort?.abort();
      this.abort = new AbortController();
      const types = ['product'];
      if (window.WB?.searchCollections) types.push('collection');
      if (window.WB?.searchArticles) types.push('article');
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=' + types.join(',') +
        '&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      try {
        const res = await fetch(url, { signal: this.abort.signal });
        const { resources } = await res.json();
        this.paint(resources.results, q);
      } catch (err) { if (err.name !== 'AbortError') this.results.innerHTML = ''; }
    }
    paint(r, q) {
      const S = window.WB?.strings || {};
      let html = '';
      if (r.products?.length) {
        html += '<div class="ps-group"><h3>' + (S.products || 'Produkte') + '</h3><div class="ps-list">';
        html += r.products.map((p) => {
          const img = p.featured_image?.url
            ? '<img src="' + p.featured_image.url + '&width=160" alt="' + (p.vendor ? p.vendor + ' ' : '') + this.esc(p.title) + '" loading="lazy" width="56" height="56">'
            : '';
          const toC = (v) => (typeof v === 'string' && v.indexOf('.') > -1) ? Math.round(parseFloat(v) * 100) : Number(v);
          const price = p.price != null ? money(toC(p.price)) : '';
          const cmp = p.compare_at_price && toC(p.compare_at_price) > toC(p.price)
            ? ' <s class="price--compare">' + money(toC(p.compare_at_price)) + '</s>' : '';
          return '<a class="ps-item" href="' + p.url + '" aria-selected="false">' +
            '<span class="ps-item__media">' + img + '</span>' +
            '<span><span class="ps-item__vendor">' + this.esc(p.vendor || '') + '</span>' +
            '<span class="ps-item__title">' + this.mark(p.title, q) + '</span></span>' +
            '<span class="ps-item__price">' + price + cmp + '</span></a>';
        }).join('');
        html += '</div></div>';
      }
      if (r.collections?.length) {
        html += '<div class="ps-group"><h3>' + (S.collections || 'Kategorien') + '</h3><div class="ps-tags">' +
          r.collections.map((c) => '<a class="chip" href="' + c.url + '">' + this.esc(c.title) + '</a>').join('') +
          '</div></div>';
      }
      if (r.articles?.length) {
        html += '<div class="ps-group"><h3>' + (S.articles || 'Ratgeber') + '</h3><div class="ps-list">' +
          r.articles.map((a) => '<a class="ps-item" href="' + a.url + '"><span class="ps-item__media"></span><span class="ps-item__title">' + this.esc(a.title) + '</span><span></span></a>').join('') +
          '</div></div>';
      }
      if (!html) html = '<p class="ps-empty">' + (S.no_results || 'Keine Treffer.') + '</p>';
      else html += '<p style="margin-top:28px"><a class="link-arrow" href="/search?q=' + encodeURIComponent(q) + '&options[unavailable_products]=hide">' + (S.view_all || 'Alle Ergebnisse') + ' &rarr;</a></p>';
      this.results.innerHTML = html;
    }
    esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    mark(title, q) {
      const t = this.esc(title);
      const needle = this.esc(q).trim();
      if (!needle) return t;
      try { return t.replace(new RegExp('(' + needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'i'), '<b>$1</b>'); }
      catch { return t; }
    }
  }
  $$('[data-predictive-search]').forEach((el) => new PredictiveSearch(el));

  /* ── Variant picker (server-rendered fragments) ───── */
  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.url = root.dataset.productUrl;
      this.sectionId = root.dataset.sectionId;
      this.variants = JSON.parse($('[data-variant-json]', root)?.textContent || '[]');
      this.form = $('form[data-product-form]', root);
      root.addEventListener('click', (e) => {
        const opt = e.target.closest('.opt');
        if (!opt || opt.getAttribute('aria-pressed') === 'true') return;
        const group = opt.closest('.option__values');
        $$('.opt', group).forEach((o) => o.setAttribute('aria-pressed', 'false'));
        opt.setAttribute('aria-pressed', 'true');
        const lbl = group.parentElement.querySelector('.option__label .val');
        if (lbl) lbl.textContent = opt.dataset.value;
        this.change();
      });
      root.addEventListener('change', (e) => { if (e.target.matches('select[data-option-index]')) this.change(); });
    }
    selected() {
      const vals = [];
      $$('[data-option-index]', this.root).forEach((g) => {
        const i = Number(g.dataset.optionIndex);
        if (g.tagName === 'SELECT') vals[i] = g.value;
        else {
          const on = g.querySelector('.opt[aria-pressed="true"]');
          if (on) vals[i] = on.dataset.value;
        }
      });
      return vals;
    }
    match(vals) {
      return this.variants.find((v) => v.options.every((o, i) => o === vals[i]));
    }
    change() {
      const vals = this.selected();
      const variant = this.match(vals);
      if (!variant && this.root.dataset.bigProduct && vals.filter(Boolean).length === this.root.querySelectorAll('[data-option-index]').length) { this.resolveRemote(vals); return; }
      this.markUnavailable(vals);
      const idInput = $('[data-variant-id]', this.root);
      if (idInput) idInput.value = variant ? variant.id : '';
      if (!variant) { this.disable(); return; }
      history.replaceState({}, '', this.url + '?variant=' + variant.id);
      this.swapMedia(variant);
      this.fetchFragments(variant.id);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    }
    async resolveRemote(vals) {
      const key = vals.join('||');
      if (this._pending === key) return;
      this._pending = key;
      const ids = Array.from(this.root.querySelectorAll('[data-option-index]')).map((g) => { const on = g.querySelector('.opt[aria-pressed="true"]'); return on ? on.dataset.valueId : ''; }).filter(Boolean).join(',');
      try {
        const res = await fetch(this.url + '?option_values=' + ids + '&section_id=variant-probe');
        const txt = await res.text();
        const m = txt.match(/<!--VP(.*?)VP-->/s);
        if (!m) throw new Error('no probe');
        const v = JSON.parse(m[1]);
        if (v && v.options && v.options.every((o, i) => o === vals[i])) { this.variants.push(v); this._pending = null; this.change(); return; }
        this.disable();
      } catch (e) { this.disable(); }
      this._pending = null;
    }
    markUnavailable(vals) {
      $$('[data-option-index]', this.root).forEach((g) => {
        const i = Number(g.dataset.optionIndex);
        $$('.opt', g).forEach((btn) => {
          const probe = vals.slice();
          probe[i] = btn.dataset.value;
          const v = this.variants.find((x) => x.options.every((o, k) => (k === i ? o === probe[i] : o === probe[k])));
          btn.dataset.unavailable = (!v && this.root.dataset.bigProduct) ? 'false' : (!v || !v.available ? 'true' : 'false');
        });
      });
    }
    disable() {
      const btn = $('[data-atc]', this.root);
      if (btn) { btn.setAttribute('aria-disabled', 'true'); const l = $('[data-atc-label]', btn); if (l) l.textContent = window.WB?.strings?.unavailable_variant || 'Nicht verfügbar'; }
    }
    swapMedia(variant) {
      if (!variant.featured_media_id) return;
      const thumb = $('[data-media-id="' + variant.featured_media_id + '"]', this.root);
      if (thumb) thumb.click();
    }
    async fetchFragments(id) {
      const target = ['[data-pdp-price]', '[data-pdp-buy]', '[data-pdp-stock]', '[data-pdp-volume]', '[data-pdp-sku]', '[data-pdp-badges]'];
      try {
        const res = await fetch(this.url + '?variant=' + id + '&section_id=' + this.sectionId);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        target.forEach((sel) => {
          const fresh = doc.querySelector(sel), cur = $(sel, this.root);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      } catch {}
    }
  }
  $$('[data-variant-picker]').forEach((el) => new VariantPicker(el));

  /* ── PDP gallery ──────────────────────────────────── */
  $$('[data-gallery]').forEach((g) => {
    const main = $('[data-gallery-main]', g);
    g.addEventListener('click', (e) => {
      const t = e.target.closest('[data-media-id]');
      if (!t || !main) return;
      $$('[data-media-id]', g).forEach((n) => n.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
      const img = t.querySelector('img');
      const mainImg = main.querySelector('img');
      if (img && mainImg) {
        mainImg.src = img.dataset.full || img.src.replace(/width=\d+/, 'width=1200');
        mainImg.srcset = '';
        mainImg.alt = img.alt;
      }
    });
  });

  /* ── Product card colour swatches ─────────────────── */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.pcard .swatch');
    if (!sw) return;
    e.preventDefault();
    const card = sw.closest('.pcard');
    const img = $('[data-card-img]', card);
    $$('.swatch', card).forEach((s) => s.setAttribute('aria-pressed', 'false'));
    sw.setAttribute('aria-pressed', 'true');
    if (img && sw.dataset.img) { img.src = sw.dataset.img; img.srcset = ''; }
    const link = $('[data-card-link]', card);
    if (link && sw.dataset.url) link.href = sw.dataset.url;
    const price = $('[data-card-price]', card);
    if (price && sw.dataset.price) price.textContent = money(Number(sw.dataset.price));
  });

  /* ── Wishlist (localStorage) ──────────────────────── */
  const WL = {
    all: () => store.get('wishlist', []),
    has: (h) => WL.all().includes(h),
    toggle(h) {
      const list = WL.all();
      const i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      store.set('wishlist', list.slice(0, 200));
      WL.paint();
      return i === -1;
    },
    paint() {
      const list = WL.all();
      $$('[data-wish]').forEach((b) => {
        const on = list.includes(b.dataset.wish);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? (window.WB?.strings?.wishlist_remove || 'Von der Merkliste entfernen') : (window.WB?.strings?.wishlist_add || 'Auf die Merkliste'));
      });
      $$('[data-wish-count]').forEach((n) => { n.textContent = list.length; n.hidden = list.length === 0; });
    }
  };
  window.WBWish = WL;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    const added = WL.toggle(b.dataset.wish);
    toast(added ? (window.WB?.strings?.wishlist_added || 'Gemerkt') : (window.WB?.strings?.wishlist_removed || 'Entfernt'));
  });
  WL.paint();
  document.addEventListener('cart:updated', () => WL.paint());

  /* wishlist page rendering */
  const wlGrid = $('[data-wishlist-grid]');
  if (wlGrid) {
    const handles = WL.all();
    const empty = $('[data-wishlist-empty]');
    if (!handles.length) { if (empty) empty.hidden = false; }
    else {
      Promise.all(handles.map((h) =>
        fetch('/products/' + h + '?view=card').then((r) => (r.ok ? r.text() : '')).catch(() => '')
      )).then((parts) => {
        wlGrid.innerHTML = parts.filter(Boolean).join('');
        WL.paint();
        if (empty) empty.hidden = wlGrid.children.length > 0;
      });
    }
  }

  /* ── Recently viewed ──────────────────────────────── */
  const pid = document.body.dataset.productId;
  if (pid) {
    const list = store.get('recent', []).filter((x) => x !== pid);
    list.unshift(pid);
    store.set('recent', list.slice(0, 12));
  }
  const rvRoot = $('[data-recently-viewed]');
  if (rvRoot) {
    const ids = store.get('recent', []).filter((x) => x !== pid).slice(0, Number(rvRoot.dataset.limit || 4));
    if (!ids.length) rvRoot.remove();
    else {
      const q = ids.map((i) => 'id:' + i).join(' OR ');
      fetch('/search?type=product&view=cards&q=' + encodeURIComponent(q))
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = $('[data-rv-grid]', rvRoot);
          const cards = doc.querySelectorAll('.pcard');
          if (!cards.length) { rvRoot.remove(); return; }
          grid.innerHTML = '';
          cards.forEach((c) => grid.appendChild(c));
          rvRoot.hidden = false;
          WL.paint();
        })
        .catch(() => rvRoot.remove());
    }
  }

  /* ── Bundle add ───────────────────────────────────── */
  $$('[data-bundle-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const ids = JSON.parse(btn.dataset.bundleAdd || '[]');
      btn.dataset.loading = 'true';
      try { await addToCart(ids.map((id) => ({ id, quantity: 1 }))); }
      catch (err) { toast(err.message); }
      finally { btn.dataset.loading = 'false'; }
    });
  });

  /* ── Sticky add to cart ───────────────────────────── */
  const sticky = $('[data-sticky-atc]');
  const anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.dataset.visible = entry.isIntersecting || entry.boundingClientRect.top > 0 ? 'false' : 'true';
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(anchor);
  }

  /* ── Collapsible SEO text ─────────────────────────── */
  $$('[data-collapsible]').forEach((el) => {
    const inner = $('[data-collapsible-body]', el);
    const btn = $('[data-collapsible-toggle]', el);
    if (!inner || !btn) return;
    if (inner.scrollHeight < 200) { btn.hidden = true; inner.dataset.collapsed = 'false'; return; }
    btn.addEventListener('click', () => {
      const open = inner.dataset.collapsed === 'false';
      inner.dataset.collapsed = open ? 'true' : 'false';
      btn.textContent = open ? (window.WB?.strings?.show_more || 'Mehr anzeigen') : (window.WB?.strings?.show_less || 'Weniger anzeigen');
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  /* ── Facets ───────────────────────────────────────── */
  $$('.facet').forEach((f) => {
    const btn = $('.facet__btn', f), panel = $('.facet__panel', f);
    if (!btn || !panel) return;
    btn.addEventListener('click', () => {
      const open = panel.dataset.open === 'true';
      $$('.facet__panel').forEach((p) => (p.dataset.open = 'false'));
      $$('.facet__btn').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      panel.dataset.open = open ? 'false' : 'true';
      btn.setAttribute('aria-expanded', String(!open));
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.facet')) $$('.facet__panel').forEach((p) => (p.dataset.open = 'false'));
  });
  const facetForm = $('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', debounce(async () => {
      const params = new URLSearchParams(new FormData(facetForm));
      for (const [k, v] of [...params.entries()]) if (!v) params.delete(k);
      const url = window.location.pathname + '?' + params.toString();
      const grid = $('[data-facet-results]');
      if (grid) grid.dataset.loading = 'true';
      try {
        const res = await fetch(url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        ['[data-facet-results]', '[data-facet-count]', '[data-facet-active]'].forEach((sel) => {
          const fresh = doc.querySelector(sel), cur = $(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        history.pushState({}, '', url);
        WL.paint();
      } finally { if (grid) grid.dataset.loading = 'false'; }
    }, 320));
  }

  /* ── Newsletter popup ─────────────────────────────── */
  const popup = $('#nl-popup');
  if (popup) {
    const cooldown = Number(popup.dataset.cooldown || 30) * 864e5;
    const last = store.get('nlSeen', 0);
    const dismissed = store.get('nlDone', false);
    if (!dismissed && Date.now() - last > cooldown) {
      setTimeout(() => (popup.dataset.open = 'true'), Number(popup.dataset.delay || 12) * 1000);
    }
    const hide = (permanent) => {
      popup.dataset.open = 'false';
      store.set('nlSeen', Date.now());
      if (permanent) store.set('nlDone', true);
    };
    $$('[data-popup-close]', popup).forEach((b) => b.addEventListener('click', () => hide(false)));
    popup.addEventListener('submit', () => hide(true));
    if (new URLSearchParams(location.search).get('customer_posted') === 'true') store.set('nlDone', true);
  }

  /* newsletter success scroll-free confirmation */
  if (new URLSearchParams(location.search).get('customer_posted') === 'true') {
    $$('[data-nl-success]').forEach((n) => (n.hidden = false));
  }

  /* ── Share ────────────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    const url = b.dataset.share || location.href;
    if (navigator.share) { try { await navigator.share({ url, title: document.title }); } catch {} }
    else { await navigator.clipboard.writeText(url); toast(window.WB?.strings?.copied || 'Link kopiert'); }
  });

  /* ── Address form (customer addresses) ────────────── */
  $$('[data-address-toggle]').forEach((b) => {
    b.addEventListener('click', () => {
      const t = document.getElementById(b.dataset.addressToggle);
      if (t) t.hidden = !t.hidden;
    });
  });
  $$('[data-address-delete]').forEach((f) => {
    f.addEventListener('submit', (e) => {
      if (!confirm(f.dataset.addressDelete)) e.preventDefault();
    });
  });
})();
/* Preis im Warenkorb-Button (data-price) bei Variantenwechsel aktualisieren */
(function () {
  var raf = 0;
  function priceText() {
    var p = document.querySelector('[data-pdp-price] .pcard__price');
    if (!p) return '';
    var c = p.cloneNode(true);
    c.querySelectorAll('s, .badge, .unit-price').forEach(function (x) { x.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function sync() {
    raf = 0;
    var t = priceText();
    if (!t) return;
    document.querySelectorAll('[data-atc][data-price]').forEach(function (b) {
      if (b.getAttribute('data-price') !== t) b.setAttribute('data-price', t);
    });
  }
  function queue() { if (!raf) raf = requestAnimationFrame(sync); }
  function boot() {
    sync();
    var root = document.querySelector('[data-variant-picker]');
    if (root) new MutationObserver(queue).observe(root, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
